var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explore-tile",class:{ 'focused-tile' : _vm.focused },attrs:{"id":"gallery-tile"},on:{"click":function($event){_vm.focused = !_vm.focused}}},[_c('img',{attrs:{"src":_vm.eventData['image_url']}})])}
var staticRenderFns = []

export { render, staticRenderFns }